import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
export const C4IPrivacyNotice = () => {
    const [policy, setPolicy] = React.useState('');
    React.useEffect(() => {
        fetch('C4IPrivacyNotice.md')
            .then((res) => (res.status === 200 ? res.text() : ''))
            .then((res) => setPolicy(res))
            .catch((err) => console.error(err));
    }, []);
    return React.createElement(ReactMarkdown, { rehypePlugins: [rehypeRaw] }, policy);
};
